import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../images/logo.png";
import "../style/Menubar.css";

const Menubar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeMenu, setActiveMenu] = useState("/");

  const location = useLocation();

  const menuItems = [
    { label: "Home", link: "/" },
    { label: "About Us", link: "/about" },
    { label: "Product", link: "/product" },
    { label: "Infrastructure", link: "/infrac" },
    { label: "Contact Us", link: "/contact" },
  ];

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location]);

  return (
    <nav className={`menubar ${scrolled ? "sticky" : "transparent"}`}>
      <div className="logo">
        <h1 style={{ display: "flex" }}>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <img src={logo} style={{ height: "50px", width: "auto" }} alt="Logo" />
            <h2 className="title2">Since 1998</h2>
          </Link>
          <div style={{fontWeight:"normal" , marginTop:"5px" , color:"grey"}}>&nbsp;|</div>

          <div style={{ paddingLeft: "10px" }}>
            <h1 id="title" >
              Sri &nbsp;Vigneswara &nbsp;Packs
            </h1>
          </div>
        </h1>
      </div>

      <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <ul className={`menu-list ${menuOpen ? "active" : ""}`}>
        {menuItems.map((item, index) => (
          <li
            key={index}
            className={`menu-item ${activeMenu === item.link ? "active" : ""}`}
            onClick={() => {
              setActiveMenu(item.link);
              setMenuOpen(false);
            }}
          >
            <Link to={item.link}>{item.label}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Menubar;
